import { trim } from 'lodash'
import type { Schema } from '@wix/document-services-types'
import { generateUniqueName } from '@wix/wix-data-client-common-standalone'

export const generateCollectionName = ({
  baseName,
  collections,
}: {
  baseName: string
  collections: Schema[]
}): string =>
  generateUniqueName(
    (prefix: string, index: number) => `${prefix} ${index}`,
    trim(baseName),
    collections.map(({ displayName }) => displayName),
    {
      allowNameWithoutSuffix: true,
      endIndex: Number.POSITIVE_INFINITY,
    },
  )
